function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#a54402;}.b{fill:#fff;opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-383 -282)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(384 284)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M19.67,12.913a8.889,8.889,0,0,0-3.87-2.745,15.142,15.142,0,0,0-11.132-.017A8.885,8.885,0,0,0,.789,12.884,3.509,3.509,0,0,0,.159,16.11a1.69,1.69,0,0,0,1.62,1.168l2.555,0h0a1.707,1.707,0,0,0,1.313-.612,1.679,1.679,0,0,0,.366-1.38c0-.014-.006-.029-.009-.043l-.134-.523a10.423,10.423,0,0,1,4.357-1.031,10.7,10.7,0,0,1,4.356,1.051l-.137.52c0,.015-.007.03-.01.044a1.679,1.679,0,0,0,.362,1.381,1.707,1.707,0,0,0,1.314.616l2.555,0h0a1.69,1.69,0,0,0,1.621-1.163A3.513,3.513,0,0,0,19.67,12.913Zm-.539,2.855a.48.48,0,0,1-.459.318h0l-2.555,0a.489.489,0,0,1-.377-.175.457.457,0,0,1-.1-.361l.254-.967a.61.61,0,0,0-.282-.682,11.816,11.816,0,0,0-5.372-1.426h-.048A11.586,11.586,0,0,0,4.85,13.876a.61.61,0,0,0-.282.679l.249.968a.457.457,0,0,1-.1.362.489.489,0,0,1-.377.174h0l-2.555,0a.48.48,0,0,1-.459-.319A2.309,2.309,0,0,1,1.775,13.6c1.392-1.9,4.94-3.284,8.441-3.284h.019c3.5.005,7.058,1.4,8.448,3.31A2.312,2.312,0,0,1,19.131,15.768Z",
  transform: "translate(0 -9.1)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.134 7.182)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M67.3,192.522l-1.905-2a.61.61,0,0,0-.442-.189H63.72V189.5a.61.61,0,0,0-1.221,0v.832H60.545V189.5a.61.61,0,1,0-1.221,0v.832H58.093a.61.61,0,0,0-.442.189l-1.905,2a8.362,8.362,0,0,0-2.316,5.791v2.511a.61.61,0,0,0,.61.61H69a.61.61,0,0,0,.61-.61v-2.511A8.361,8.361,0,0,0,67.3,192.522Zm-12.648,7.692v-1.9a7.146,7.146,0,0,1,1.98-4.949l1.725-1.811H64.69l1.725,1.811a7.146,7.146,0,0,1,1.98,4.949v1.9Z",
  transform: "translate(-53.43 -188.89)"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(7.033 11.107)"
}, /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M179.24,287.135a3.194,3.194,0,1,0,3.194,3.194A3.2,3.2,0,0,0,179.24,287.135Zm0,5.168a1.974,1.974,0,1,1,1.974-1.974A1.976,1.976,0,0,1,179.24,292.3Z",
  transform: "translate(-176.046 -287.135)"
}))), /*#__PURE__*/React.createElement("rect", {
  className: "b",
  width: 23,
  height: 23,
  transform: "translate(383 282)"
}));

var SvgIcnTelephone = function SvgIcnTelephone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTelephone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_telephone.0cf763c6.svg";
export { ForwardRef as ReactComponent };